import { addDays as g } from "./addDays.js";
import { toDate as i } from "./toDate.js";
import { getDefaultOptions as x } from "./_lib/defaultOptions.js";
function h(D, e, t) {
  var s, f, d, l, m, o, O, u;
  const a = x(), k = (u = (O = (l = (d = t == null ? void 0 : t.weekStartsOn) != null ? d : (f = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : f.weekStartsOn) != null ? l : a.weekStartsOn) != null ? O : (o = (m = a.locale) == null ? void 0 : m.options) == null ? void 0 : o.weekStartsOn) != null ? u : 0, n = i(D), c = n.getDay(), w = (e % 7 + 7) % 7, r = 7 - k, S = e < 0 || e > 6 ? e - (c + r) % 7 : (w + r) % 7 - (c + r) % 7;
  return g(n, S);
}
export {
  h as default,
  h as setDay
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/setDay.js
// module id = 432
// module chunks = 41